import { connect } from "react-redux";

import type {
  RelatedPublicTrip,
  RelatedPublicSegment,
  PublicTrip,
  RelatedPublicSegmentV4,
  RelatedPublicTripV4,
  PublicTripV4,
  PublicSegment,
  PublicSegmentV4
} from "@busbud/core-types/dist/lib/poll-service/api";

import { getSegmentsPerDirection } from "@app/modules/checkout/store/v2/selectors/get-segments-per-direction";
import type { TripStopsFetchStatusKey } from "@app/modules/results/state/trip-stops-fetch-status";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import type { OwnProps } from "./itinerary";
import type { NormalizedTripStopAndTransfers } from "./types";

import { Itinerary as ItineraryComponent } from "./itinerary";
import { isReturn } from "../../helpers/search";
import { tripStopsGenerationFromRelatedModels } from "../../helpers/udm/trip-stops-generation";
import {
  getSearch,
  getTripStopsFetchStatus,
  getTripsCities,
  getTripsLocations,
  getTripsOperators
} from "../../modules/results/selectors/state-accessors";
import { getSearchedLegHasUnreliableDuration } from "../../modules/results/selectors/trips/get-searched-leg-has-unreliable-duration";
import { getSearchedLegSegments } from "../../modules/results/selectors/trips/get-segments";
import { getTripById } from "../../modules/results/selectors/trips/get-trip";

export type StateProps = {
  direction: "outbound" | "return";
  hide_time?: boolean;
  segments: (
    | RelatedPublicSegment
    | RelatedPublicSegmentV4
    | PublicSegment
    | PublicSegmentV4
  )[];
  trip_info:
    | RelatedPublicTrip
    | PublicTrip
    | RelatedPublicTripV4
    | PublicTripV4;
  trip_stops_and_transfers: NormalizedTripStopAndTransfers;
  trip_stops_fetch_status: TripStopsFetchStatusKey;
};

const mapStateToProps = (
  state: ResultsReduxState,
  own_props: OwnProps & { trip_id: string }
): StateProps => {
  const search = getSearch(state);
  const trip_stops_fetch_status = getTripStopsFetchStatus(state);

  // This component is re-used for Results and other pages.
  // Results Page is based on the search and searched leg.
  // Checkout page & Payment Confirmation is based in the own_props.direction informed.
  const direction =
    own_props.direction || (isReturn(search) ? "return" : "outbound");

  let trip_stops_and_transfers: NormalizedTripStopAndTransfers = [];
  const trip_id = own_props.trip_id;

  const trip_info = getTripById(state, trip_id);

  const trip_segments = own_props.direction
    ? getSegmentsPerDirection(state, trip_id, direction)
    : getSearchedLegSegments(state, trip_id);

  const trip_locations = getTripsLocations(state);
  const trip_operators = getTripsOperators(state);
  const trip_cities = getTripsCities(state);

  trip_stops_and_transfers = tripStopsGenerationFromRelatedModels(
    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    trip_segments,
    trip_locations,
    trip_operators,
    trip_cities
  );

  const hide_time = getSearchedLegHasUnreliableDuration(state, trip_id);

  return {
    direction,
    hide_time,
    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    segments: trip_segments,
    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    trip_info,
    trip_stops_and_transfers,
    trip_stops_fetch_status
  };
};

const connector = connect(mapStateToProps);
export const Itinerary = connector(ItineraryComponent);
